import * as types from './actionTypes';
import handleErrors from './handleErrors';
import getAPIPath from '../../js/modules/api-location';
import { addNotification } from './notificationActions';

export function getPaymentBillingSuccess(data) {
  return { type: types.GET_PAYMENT_BILLING_SUCCESS, data };
}

export function updateAwaitingDowngradeSuccess(awaiting) {
  return { type: types.UPDATE_AWAITING_DOWNGRADE_SUCCESS, awaiting };
}

export function getPaymentBilling() {
  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/payments/billing`, {
      method: `GET`,
      credentials: `include`,
      header: {
        Accept: `application/json`,
      },
    })
    .then(handleErrors)
    .then(response => response.json().then((res) => {
      dispatch(getPaymentBillingSuccess(res.data));
    }))
    .catch((error) => {
      throw error;
    });
  };
}

export function updateAwaitingDowngrade(awaiting) {
  const item = {};
  item.awaiting_downgrade = awaiting;

  return function(dispatch) {
    return fetch(`${getAPIPath}commandapi/payments/update-awaiting-downgrade`, {
      method: `PUT`,
      body: JSON.stringify(item),
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
    .then(handleErrors)
    .then(dispatch(updateAwaitingDowngradeSuccess(awaiting)))
    .catch(response => response.json().then((res) => {
      dispatch(addNotification({
        message: res.message,
        level: `error`,
        autoDismiss: 0,
      }));
      throw res;
    }));
  };
}


// WEBPACK FOOTER //
// ./library/app/actions/billingActions.js